"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
require("./PageTitle.css");
var Text_1 = __importDefault(require("../Text"));
var Link_1 = __importDefault(require("../Link"));
var Title_1 = __importDefault(require("../Title"));
function PageTitle(_a) {
    var title = _a.title, subtitle = _a.subtitle, link = _a.link;
    var renderSubtitle = subtitle && React.createElement(Text_1.default, null, subtitle);
    var renderLink = link && (React.createElement(Link_1.default, { href: link.href, onClick: link.onClick, appearance: link.appearance, underline: link.underline, disabled: link.disabled, icon: link.icon, iconSize: link.iconSize, spinner: link.spinner, iconPosition: link.iconPosition, target: link.target }, link.children));
    var renderSubtitleLink = (subtitle || link) && (React.createElement("div", { className: "nimbus--page-subtitle" },
        renderSubtitle,
        renderLink));
    return (React.createElement("div", { className: "nimbus--page-title" },
        React.createElement(Title_1.default, null, title),
        renderSubtitleLink));
}
var Skeleton = function () { return React.createElement("div", { className: "nimbus--page-title-skeleton" }); };
PageTitle.Skeleton = Skeleton;
exports.default = PageTitle;
//# sourceMappingURL=index.js.map